import { Delete } from "@mui/icons-material";
import { lighten, styled, Toolbar, Tooltip, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import clsx from "clsx";
import { useAuthStatus } from "helpers/useAuthStatus";

const PREFIX = "ViewGroupsPageTableToolbar";

const classes = {
	root: `${PREFIX}-root`,
	highlight: `${PREFIX}-highlight`,
	title: `${PREFIX}-title`,
};

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	[`&.${classes.root}`]: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},

	[`&.${classes.highlight}`]:
		theme.palette.mode === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },

	[`& .${classes.title}`]: {
		flex: "1 1 100%",
	},
}));

export interface ViewGroupsPageTableToolbarProps {
	numSelected: number;
	handleDelete: () => void;
	children?: JSX.Element;
}

export const ViewGroupsPageTableToolbar = ({
	numSelected,
	handleDelete,
	children,
}: ViewGroupsPageTableToolbarProps): JSX.Element => {
	const { role } = useAuthStatus();
	return (
		<StyledToolbar
			className={clsx(classes.root, {
				[classes.highlight]: numSelected > 0,
			})}
		>
			{numSelected > 0 ? (
				<>
					<Typography
						className={classes.title}
						color="inherit"
						variant="subtitle1"
						component="div"
					>
						{numSelected} selected
					</Typography>
					{role !== "student" && (
						<Tooltip title="Delete">
							<IconButton
								data-testid="delete-button"
								onClick={handleDelete}
								aria-label="delete"
								size="large"
							>
								<Delete />
							</IconButton>
						</Tooltip>
					)}
				</>
			) : (
				<>
					<Typography
						className={classes.title}
						variant="h6"
						id="tableTitle"
						component="div"
					>
						Student List
					</Typography>
					{children}
				</>
			)}
		</StyledToolbar>
	);
};
